const API_BASE = process.env.REACT_APP_API_BASE || '/api';

async function request(path, opts = {}) {
  const res = await fetch(API_BASE + path, opts);
  const text = await res.text();
  let body = null;
  try { body = JSON.parse(text); } catch (e) { body = text; }
  if (!res.ok) {
    console.debug('api/cart request failed', { path, status: res.status, body });
  } else {
    console.debug('api/cart request', { path, status: res.status, body });
  }
  return body;
}

export async function addToCart({ productId, quantity = 1, variantId, guestId, token }) {
  // do not send guestId when authenticated - server will associate via token
  const body = token ? { productId, quantity, variantId } : { productId, quantity, variantId, guestId };
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return request('/cart/add', { method: 'POST', headers, body: JSON.stringify(body) });
}

export async function getCart({ guestId, token } = {}) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = guestId ? `?guestId=${encodeURIComponent(guestId)}` : '';
  return request('/cart' + qs, { method: 'GET', headers });
}

export async function updateQuantity({ id, quantity, guestId, token }) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = guestId ? `?guestId=${encodeURIComponent(guestId)}` : '';
  return request(`/cart/${id}${qs}`, { method: 'PUT', headers, body: JSON.stringify({ quantity, guestId }) });
}

export async function removeItem({ id, guestId, token }) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = guestId ? `?guestId=${encodeURIComponent(guestId)}` : '';
  return request(`/cart/${id}${qs}`, { method: 'DELETE', headers });
}

export async function mergeCart({ guestId, token }) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return request('/cart/merge', { method: 'POST', headers, body: JSON.stringify({ guestId }) });
}
